import { Reveal } from "@/components/Reveal";
import { Star } from "lucide-react";

const reviews = [
  {
    quote:
      "They transformed our rooftop into the best bar in the city for one night. Guests are still talking about the smoked old fashioned.",
    name: "Amara & James",
    role: "Wedding · Brooklyn",
  },
  {
    quote:
      "Seamless from setup to last call. The signature menu they designed for our launch was exactly on-brand.",
    name: "Nadia K.",
    role: "Product Launch · SoHo",
  },
  {
    quote:
      "Professional, charismatic, and genuinely talented. The zero-proof cocktails were as impressive as the rest.",
    name: "Marcus D.",
    role: "Corporate Gala · Manhattan",
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-12 bg-[#0a0a0a] border-y border-[#222]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto">
        <Reveal className="mb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-5">Word of Mouth</p>
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl tracking-tight leading-none">
            Loved by <span className="italic gold-shimmer">hosts.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-${i}`}
                className="h-full flex flex-col justify-between p-8 bg-[#050505] border border-[#222] hover:border-gold/40 transition-colors duration-500"
              >
                <div className="flex gap-1 mb-6">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star key={k} size={15} className="fill-gold text-gold" />
                  ))}
                </div>
                <blockquote className="font-heading text-xl md:text-2xl leading-snug text-white/90 flex-1">
                  “{r.quote}”
                </blockquote>
                <figcaption className="mt-8 pt-5 border-t border-[#222]">
                  <div className="text-sm text-white">{r.name}</div>
                  <div className="text-xs uppercase tracking-[0.2em] text-gold mt-1">{r.role}</div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
